// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__JB5ZV","selected":"styles_selected__3mcsO"};